
import LeadType from "../TableItems/LeadType";
import LafId from "../../Portfolio/TableItems/LafId";

export default [
	{ title: 'Case ID', field: 'cl_lead_id', component: LafId},
	{ title: 'LAF ID', field: 'laf_id'},
	{ title: 'LAN ID', field: 'lan_id' },
	{ title: 'CLM Type', field: 'lead_type',component:LeadType },
	{ title: 'Customer Name', field: 'cust_name' },
	// { title: 'Lead ID', field: 'lead_id' },
	// { title: 'Application ID', field: 'application_id' },
	{ title: 'Created At', field: 'created_at' },
	{ title: 'Status', field: 'action' },
];